export const ATTRACTOR = Object.freeze({
  LORENZ: 0,
  FOUR_WING: 1,
  THOMAS: 2,
  AIZAWA: 3,
  ROESSLER: 4,
  SPROTT: 5,
  DADRAS: 6,
  HALVORSEN: 7,
})

export const attractors = [
  {
    id: ATTRACTOR.LORENZ,
    label: 'Lorenz',
    shortcut: '1'
  },
  {
    id: ATTRACTOR.FOUR_WING,
    label: 'Four-Wing',
    shortcut: '2'
  },
  {
    id: ATTRACTOR.THOMAS,
    label: 'Thomas',
    shortcut: '3'
  },
  {
    id: ATTRACTOR.AIZAWA,
    label: 'Aizawa',
    shortcut: '4'
  },
  {
    id: ATTRACTOR.ROESSLER,
    label: 'Roessler',
    shortcut: '5'
  },
  {
    id: ATTRACTOR.SPROTT,
    label: 'Sprott B',
    shortcut: '6'
  },
  {
    id: ATTRACTOR.DADRAS,
    label: 'Dadras',
    shortcut: '7'
  },
  {
    id: ATTRACTOR.HALVORSEN,
    label: 'Halvorsen',
    shortcut: '8'
  }
]
